import React from 'react'
import noop from 'lib/function/noop'
import type { DevPanelAction } from './types'

export const DevPanelDispatchContext = React.createContext<(action: DevPanelAction) => void>(noop)
